<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         src="@/assets/theme/light/status/01dailyActive/01back.svg">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('setPlanDate.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <van-calendar
                type="multiple"
                :default-date=duplicateDate
                :show-title="false"
                :poppable="false"
                :show-confirm="false"
                :readonly="true"
                :min-date="new Date(startDate)"
                :max-date="new Date(endDate)"
                color="var(--chart-color-1)"
                :row-height="38 * ratio"
                :style="{ height: 300 * ratio + 'px' }"
            />
            <div class="info-box">
                <van-row>
                    <van-col span="12">
                        <div class="plan-name">{{ $t('setPlanDate.repeatWeek') }}</div>
                    </van-col>
                    <van-col span="12">
                        <div class="plan-name-input" @click="openRepeatPop">
                            <div class="vertically-center">
                                <span class="selected">{{ getRepeatWeekText() }}</span>
                                <img class="to-img" src="@/assets/theme/light/status/01dailyActive/06to.svg">
                            </div>
                        </div>
                    </van-col>
                </van-row>
                <van-row>
                    <van-col span="8">
                        <div class="plan-name">{{ $t('setPlanDate.startDate') }}</div>
                    </van-col>
                    <van-col span="16">
                        <div class="plan-name-input" @click="showStartDatePop = true">
                            <div class="vertically-center">
                                <span class="selected">{{ startDate }}</span>
                                <img class="to-img" src="@/assets/theme/light/status/01dailyActive/06to.svg">
                            </div>
                        </div>
                    </van-col>
                </van-row>
                <van-row>
                    <van-col span="12">
                        <div class="plan-name">{{ $t('setPlanDate.endDate') }}</div>
                    </van-col>
                    <van-col span="12">
                        <div class="plan-name-input" @click="showEndDatePop = true">
                            <div class="vertically-center">
                                <span class="selected">{{ endDate }}</span>
                                <img class="to-img" src="@/assets/theme/light/status/01dailyActive/06to.svg">
                            </div>
                        </div>
                    </van-col>
                </van-row>
                <van-row>
                    <van-col span="12">
                        <div class="plan-name">{{ $t('setPlanDate.isRemind') }}</div>
                    </van-col>
                    <van-col span="12">
                        <div class="plan-name-input">
                            <div class="vertically-center">
                                <van-switch v-model="isRemind" active-color="var(--chart-color-1)" :size="20 * ratio + 'px'"/>
                            </div>
                        </div>
                    </van-col>
                </van-row>
                <van-row v-if="isRemind">
                    <van-col span="12">
                        <div class="plan-name">{{ $t('setPlanDate.remindTime') }}</div>
                    </van-col>
                    <van-col span="12">
                        <div class="plan-name-input" @click="showRemindTimePop = true">
                            <div class="vertically-center">
                                <span class="selected">{{ remindTime }}</span>
                                <img class="to-img" src="@/assets/theme/light/status/01dailyActive/06to.svg">
                            </div>
                        </div>
                    </van-col>
                </van-row>
            </div>
            <div class="import-box" @click="addUserTrainPlan">
                <div><img class="import-img" src="@/assets/theme/light/trainPlan/05setPlanDate/02can.svg"></div>
                <div>{{ $t('setPlanDate.import') }}</div>
            </div>
        </div>
        <van-popup v-model="showRepeatPop" round position="bottom">
            <div class="repeat-box">
                <van-checkbox-group v-model="repeatWeekChange">
                    <van-cell-group :border="false">
                        <van-cell
                            v-for="(item, index) in list"
                            :key="item"
                            :title=item
                            :border="false"
                            @click="toggle(index)"
                        >
                            <template #right-icon>
                                <van-checkbox checked-color="var(--chart-color-1)" :name="index" ref="checkboxes"/>
                            </template>
                        </van-cell>
                    </van-cell-group>
                </van-checkbox-group>
                <div class="btn-box">
                    <van-row>
                        <van-col span="12" class="cancel" @click="showRepeatPop = false">{{
                                $t('setPlanDate.cancel')
                            }}
                        </van-col>
                        <van-col span="12" class="confirm" @click="confirm">{{ $t('setPlanDate.confirm') }}</van-col>
                    </van-row>
                </div>
            </div>
        </van-popup>

        <van-popup v-model="showStartDatePop" round position="bottom">
            <van-datetime-picker
                v-model="startDateChange"
                type="date"
                :min-date="minDate"
                @confirm="onConfirmPartStart"
                @cancel="onCancelPartStart"
                :title="$t('setPlanDate.startDate')"
            />
        </van-popup>

        <van-popup v-model="showEndDatePop" round position="bottom">
            <van-datetime-picker
                v-model="endDateChange"
                type="date"
                :min-date="minDate"
                @confirm="onConfirmPartEnd"
                @cancel="onCancelPartEnd"
                :title="$t('setPlanDate.endDate')"
            />
        </van-popup>
        <van-popup v-model="showRemindTimePop" round position="bottom">
            <van-datetime-picker
                v-model="remindTimeChange"
                type="time"
                @confirm="onConfirmRemindTime"
                @cancel="onCancelRemindTime"
                :title="$t('setPlanDate.remindTime')"
            />
        </van-popup>
    </div>
</template>

<script>
import {
    getWeekNum,
    getToday,
    getTodayNextMonth,
    getStr
} from "../../utils/dateUtils";
import {addUserTrainPlan, getCurrentUserPlanCount} from "../../api/trainPlan";
import {Toast} from "vant";
import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: 'setPlanDate',
    data() {
        return {
            ratio: 1,
            repeatWeek: [getWeekNum()],
            startDate: getToday(),
            endDate: getTodayNextMonth(),
            startDateChange: getToday(),
            endDateChange: getTodayNextMonth(),
            duplicateDate: [],
            showRepeatPop: false,
            list: [this.$t('setPlanDate.week0'), this.$t('setPlanDate.week1'), this.$t('setPlanDate.week2'), this.$t('setPlanDate.week3'), this.$t('setPlanDate.week4'), this.$t('setPlanDate.week5'), this.$t('setPlanDate.week6')],
            repeatWeekChange: [],
            showStartDatePop: false,
            showEndDatePop: false,
            minDate: new Date(),
            planId: 0,
            isRemind: false,
            remindTime: '18:00',
            remindTimeChange: '18:00',
            showRemindTimePop: false,
            from: ''
        }
    },
    mounted() {
        this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
        this.getRepeatDate();
        if (this.$route.query.planId) {
            this.planId = this.$route.query.planId;
        }
        if (this.$route.query.from) {
            this.from = this.$route.query.from;
        }
    },
    methods: {
        back() {
            if (this.from === 'web') {
                this.$router.go(-2)
            } else {
                WebJSBridge.call("closeWeb", null, function (res) {
                });
            }
        },
        toggle(index) {
            this.$refs.checkboxes[index].toggle();
        },
        openRepeatPop() {
            this.repeatWeekChange = this.repeatWeek;
            this.showRepeatPop = true;
        },
        confirm() {
            if (this.repeatWeekChange.length === 0) {
                this.$toast({
                    message: this.$t('setPlanDate.repeatTips'),
                    duration: 1000
                });
                return;
            }
            this.repeatWeek = this.repeatWeekChange.sort((a, b) => a - b);
            this.showRepeatPop = false;
            this.getRepeatDate();
        },
        getRepeatWeekText() {
            if (this.repeatWeek.length === 1) {
                return this.$t('setPlanDate.repeatText') + this.$t('setPlanDate.repeatText' + this.repeatWeek[0]);
            } else if (this.repeatWeek.length === 7) {
                return this.$t('setPlanDate.repeatText7')
            } else {
                let text = this.$t('setPlanDate.repeatText');
                for (let i = 0; i < this.repeatWeek.length; i++) {
                    if (i === this.repeatWeek.length - 1) {
                        text = text + this.$t('setPlanDate.repeatText' + this.repeatWeek[i])
                    } else {
                        text = text + this.$t('setPlanDate.repeatText' + this.repeatWeek[i]) + this.$t('setPlanDate.repeatTextSplit');
                    }

                }
                return text;
            }

        },
        onConfirmPartStart(value) {
            this.startDate = getStr(value);
            this.startDateChange = getStr(value);
            this.dealDate();
            this.showStartDatePop = false;
        },
        onCancelPartStart() {
            this.showStartDatePop = false;
            this.startDateChange = this.startDate;
        },
        onConfirmPartEnd(value) {
            this.endDate = getStr(value);
            this.endDateChange = getStr(value);
            this.dealDate();
            this.showEndDatePop = false;
        },
        onCancelPartEnd() {
            this.showEndDatePop = false;
            this.endDateChange = this.endDate;
        },
        dealDate() {
            if (this.startDate > this.endDate) {
                let temp = this.startDate;
                this.startDate = this.endDate;
                this.endDate = temp;
            }
            this.getRepeatDate();
        },
        getRepeatDate() {
            let repeat = this.repeatWeek;
            let startDate = new Date(this.startDate);
            let endDate = new Date(this.endDate);
            let result = [];

            // 遍历日期范围
            while (startDate <= endDate) {
                let dayOfWeek = (startDate.getDay() + 6) % 7; // 调整星期几的表示方式
                if (repeat.includes(dayOfWeek)) {
                    result.push(new Date(startDate)); // 将符合条件的日期加入结果数组
                }
                startDate.setDate(startDate.getDate() + 1); // 增加一天
            }
            this.duplicateDate = result;
        },
        addUserTrainPlan() {
            if (!this.planId) {
                Toast({message: this.$t('setPlanDate.planErrorMsg')});
                return;
            }
            this.$api.trainPlan.getCurrentUserPlanCount().then(res => {
                if (res.info >= 10) {
                    Toast({message: this.$t('setPlanDate.maxTip')});
                } else {
                    this.$api.trainPlan.addUserTrainPlan({
                        planId: this.planId,
                        startDate: this.startDate,
                        endDate: this.endDate,
                        weeklyRepeat: this.repeatWeek.toString(),
                        isRemind: this.isRemind ? 1 : 0,
                        remindTime: this.remindTime
                    }).then(res => {
                        if (this.from === 'web') {
                            this.$router.go(-2)
                        } else {
                            WebJSBridge.call("calendarEditSuccess", null, function (res) {
                            });
                            WebJSBridge.call("closeWeb", null, function (res) {
                            });
                        }
                    })
                }
            })
        },
        onConfirmRemindTime() {
            this.remindTime = this.remindTimeChange;
            this.showRemindTimePop = false;
        },
        onCancelRemindTime() {
            this.showRemindTimePop = false;
            this.remindTimeChange = this.remindTime;
        },
    }
}
</script>

<style scoped>
.content {
    width: 100%;
    margin-top: 98px;
    color: var(--text-color-1);
}

/deep/ .van-calendar__weekdays {
    color: var(--text-color-2);
}

/deep/ .van-calendar {
    background-color: transparent;
}

/deep/ .van-calendar__month-title {
    display: none;
}

/deep/ .van-calendar__month-mark {
    color: var(--text-color-3);
}

/deep/ .van-calendar__header {
    box-shadow: none;
}

.info-box {
    width: 345px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 15px auto;
    padding: 8px 0;
}

.plan-name {
    font-size: 15px;
    color: var(--text-color-2);
    line-height: 50px;
    margin-left: 18px;
}

.plan-name-input {
    width: 200px;
    float: right;
    margin-right: 22px;
    text-align: right;
}

.repeat-box {
    width: 345px;
    height: 368px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 15px auto 0;
}

.btn-box {
    width: 345px;
    height: 56px;
    border-top: 1px solid var(--bg-color-1);
}

.cancel {
    font-size: 17px;
    color: var(--text-color-2);
    text-align: center;
    line-height: 56px;
}

.confirm {
    font-size: 17px;
    color: var(--chart-color-1);
    text-align: center;
    line-height: 56px;
}

.vertically-center {
    display: flex;
    align-items: center;
    justify-content: right;
    height: 50px;
}

.selected {
    font-size: 15px;
    color:var(--text-color-1);
}

/deep/ .van-picker__toolbar {
    height: 57px;
}

/deep/ .van-picker__title {
    color: var(--text-color-1);
    font-size: 17px;
}

/deep/ .van-picker__confirm {
    color: var(--chart-color-1);
    font-size: 17px;
}

/deep/ .van-picker__cancel {
    font-size: 17px;
    color: var(--text-color-2);
}

/deep/ .van-calendar__day {
    margin: 5px 0;
}

.import-box {
    width: 345px;
    height: 65px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin: 20px auto;
    text-align: center;
    font-size: 12px;
}

.import-img {
    width: 16px;
    height: 16px;
    margin-top: 13px;
}

/deep/ .van-popup {
    background-color: var(--bg-color-2);
}

/deep/ .van-cell-group {
    background-color: var(--bg-color-2);
}

/deep/ .van-cell {
    background-color: var(--bg-color-2);
    color: var(--text-color-1);
}

/deep/ .van-picker {
    background-color: var(--bg-color-2);
    color: var(--text-color-1);
}

/deep/ .van-picker__mask {
    background-image: none;
}

/deep/ .van-picker-column__item {
    color: var(--text-color-1);
}
</style>


// WEBPACK FOOTER //
// src/views/trainPlan/05setPlanDate.vue